import React from "react";
import NGITable from "components/Common/NGITable";

const CookingSessionsTab = ({ list = [], update, isLoading, columns = [] }) => (
  <NGITable isLoading={isLoading} updateList={update} columns={columns} data={list} />
);

export default CookingSessionsTab;
